'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Disclaimer = function (props) { return (React__default['default'].createElement("svg", tslib_es6.__assign({ xmlns: "http://www.w3.org/2000/svg", width: "38", height: "38", viewBox: "0 5 50 38", fill: "currentColor" }, props),
    React__default['default'].createElement("defs", null,
        React__default['default'].createElement("path", { id: "if8aicoima", d: "M25 13.75c6.213 0 11.25 5.037 11.25 11.25S31.213 36.25 25 36.25 13.75 31.213 13.75 25 18.787 13.75 25 13.75zM25 15c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10zm-.288 13.918c.526 0 .945.437.945.945 0 .56-.42.98-.945.98-.542 0-.962-.42-.962-.98 0-.508.42-.945.962-.945zm.228-10.168c.21 0 .385.175.385.385v7.315c0 .192-.175.385-.385.385h-.525c-.192 0-.385-.193-.385-.385v-7.315c0-.21.192-.385.385-.385h.525z" })),
    React__default['default'].createElement("g", { fill: "none", fillRule: "evenodd" },
        React__default['default'].createElement("mask", { id: "rst131ajub", fill: "#fff" },
            React__default['default'].createElement("use", { href: "#if8aicoima" })),
        React__default['default'].createElement("use", { fill: "#323232", fillRule: "nonzero", href: "#if8aicoima" }),
        React__default['default'].createElement("path", { fill: "#323232", mask: "url(#rst131ajub)" })))); };

exports.default = Disclaimer;
//# sourceMappingURL=index.js.map
